export const isTransactional = (program: any, canWatch: boolean, hasEntitlementStatic?:boolean) => {
    return (
        program &&
        !canWatch &&
        program.modelType === 'vod' && 
        program.purchaseType === 'TVOD' &&
        (hasEntitlementStatic ?? program.hasEntitlementState)
    )
}